module.exports = __webpack_public_path__ + "static/media/sprite.958fc6e8.png";